
import {debounce} from "@/utils/debounce";
export default {
  name: "password",
  auth: 'guest',
  data() {
      return {
          form: {
              phone: "",
              certify: "",
          },
          timer: null,
          isCertifyCalled: false,
          numberCertificated: false,
          time: 180,
          leftTimes: '03:00',
          count: 0,
          maxCount: 0,
          errors: {},
      }
  },
  watch: {
    time(value) {
      let min = parseInt(value / 60, 10);
      let sec = parseInt(value % 60 ,10);
      min = min < 10 ? '0' + min : min;
      sec = sec < 10 ? '0' + sec : sec;
      this.leftTimes = min + ':' + sec;
    }
  },
  computed: {
    computedTimerClass() {
      return `timer ${this.time <= 0 ? 'expired' : ''}`;
      
    }
  },  
  methods: {
    async certificate() {
        if(this.time !== 180) {
          return alert('인증번호 보내기는 3분에 한번만 가능합니다.')
        }
        if(!this.form.phone) {
          return alert('연락처를 입력해주세요.');
        }
        try {
            if(!this.isCertifyCalled) {
              this.form.certify = '';
            }
            const { data } = await this.$axios.get('/api/user-certify', {
                params: {
                    ...this.form
                }
            });
            if (data.result) {
                this.isCertifyCalled = true;
                this.count++;
                this.startTimer();
            } else if(data.message == 'max limit') {
              this.maxCount = data.count - 1;
              alert(`인증번호 만료횟수가 ${this.maxCount}번 초과하였습니다. 고객센터(1544-7166)으로 연락바랍니다.`);
            }
        } catch (e) {
          if (e.response.data.errors) {
              this.errors = e.response.data.errors;

          }else {
            alert(e.response.data.error)
          } 

            
        }
    },
    async cirtificateWithNumber() {
      if(!this.form.phone) {
        return alert('연락처를 입력해주세요.');
      }
      if(!this.form.certify) {
        return alert('인증번호를 입력해주세요.');
      }
      try {
            const { data } = await this.$axios.get('/api/user-certify', {
                params: {
                    ...this.form
                }
            });
            if (data.result) {
                this.numberCertificated = true;
            }
        } catch (e) {
            if(e.response.data.message) {
              alert(e.response.data.message);
            }
        }
    },

    async changePassword() {
      if(this.isCertifyCalled && !this.numberCertificated) {
        return alert('인증번호를 입력후 확인을 눌러주세요.');
      }
      if(this.numberCertificated && !this.isCertifyCalled) {
        return alert('인증번호가 만료되었습니다. 인증번호를 다시 받아주세요.');
      }
      if(this.maxCount !== 0 && this.count > this.maxCount) {
        return alert(`인증번호를 만료횟수가 ${this.maxCount}번 초과하였습니다. 고객센터(1544-7166)으로 연락바랍니다.`);
      }
      try {
        const { data } = await this.$axios.post('/api/password-reset', {
          phone: this.form.phone,
        });
        if (data.result) {
            alert('임시 비밀번호가 발송되었습니다. 문자메세지를 확인해주세요.');
            this.$router.push('/auth/login');
        } else if (data.result == false && data.message == 'max limit') {
          alert(`인증번호 만료횟수가 ${this.maxCount}번 초과하였습니다. 고객센터(1544-7166)으로 연락바랍니다.`);
        } else if (data.result == false) {
          alert('인증번호가 잘못 입력되었습니다. 다시 입력해주세요.');
        }
      } catch (e) {
        console.log(e);
      }
    },
    startTimer() {
        this.timer = setInterval(() => {
            if (this.time > 0) {
                this.time--;
            } else {
                clearInterval(this.timer);
                this.time = 180;
                this.isCertifyCalled = false;
            }
        }, 1000);
    },
  },
  created () {
        this.debounceCertificate = debounce(() => {
            this.certificate()
        },500);
    },
}
